import { PageType } from "@product/scmp-sdk";

export const pathname = "/posties/video";

export const page = {
  route(query: QueryParameters<{ entityId?: string }>) {
    return { pathname, query: { ...query, pageType: PageType.PostiesVideo } };
  },
};
